import React from 'react';
import { usePromiseTracker } from "react-promise-tracker";
import LoadingSpinner from './LoadingSpinner';

interface Props {
  area?: string;
  delay?: number;
  spinnerSizeInRem?: number;
}

const PromiseLoadingSpinner = ({ area, delay, spinnerSizeInRem }: Props) => {
  // promise tracker hook
  const { promiseInProgress } = usePromiseTracker({area: area, delay: delay});

  // render
  if (promiseInProgress /*|| true*/) {
    return (
      <LoadingSpinner sizeInRem={spinnerSizeInRem} />
    )   
  } else {
    return null;
  }
}

export default PromiseLoadingSpinner;
